import React from "react";
import { Mail, Github, Users } from "lucide-react";

const AboutPage: React.FC = () => {
  return (
    <div className="flex justify-center items-start min-h-screen bg-orange-50 pt-[120px] pb-[80px] px-4">
      <div className="bg-white/90 backdrop-blur-sm shadow-xl rounded-2xl p-8 sm:p-10 max-w-3xl w-full text-center border border-orange-100">
        {/* === TITLE === */}
        <h1 className="text-3xl sm:text-4xl font-bold text-orange-600 mb-4">
          🍲 Om FonteneLunsj
        </h1>

        {/* === INTRO TEXT === */}
        <p className="text-gray-700 leading-relaxed mb-6">
          Velkommen til <strong>FonteneLunsj</strong> – et digitalt fellesskap
          for matglede! Her deler vi oppskrifter, vurderinger og inspirasjon fra
          kjøkkenet på Fontenehuset. Målet er å samle gode smaker, minner og
          ideer på ett sted – slik at alle kan bidra, oppdage og lage noe nytt
          sammen.
        </p>

        <hr className="border-orange-200 my-6" />

        {/* === FEATURES SECTION === */}
        <div className="space-y-4 text-left sm:text-center">
          <p className="text-gray-700">
            📅 <strong>Kalenderen</strong> lar deg se hva som ble laget ulike
            dager, og finne igjen favorittene dine.
          </p>
          <p className="text-gray-700">
            ⭐ <strong>Oppskriftsoversikten</strong> viser alle retter, med
            bilder, beskrivelser og vurderinger.
          </p>
          <p className="text-gray-700">
            👥 <strong>Brukerkontoer</strong> gjør det mulig å logge inn for å
            foreslå nye retter.
          </p>
        </div>

        <hr className="border-orange-200 my-6" />

        {/* === COMMUNITY MESSAGE === */}
        <div className="text-gray-700 leading-relaxed">
          <p className="mb-3">
            Appen er laget med fokus på fellesskap, matglede og inkludering – et
            verktøy som gjør det enklere å ta vare på oppskrifter, idéer og gode
            øyeblikk.
          </p>

          <p className="text-sm text-gray-500 italic mt-6">
            © {new Date().getFullYear()} Fontenehuset Oslo Sør – Laget med ❤️
            for mat og fellesskap.
          </p>
        </div>

        {/* === TEAM / CONTACT SECTION === */}
        <div className="mt-10 border-t border-orange-200 pt-6">
          <h2 className="text-xl font-semibold text-orange-600 mb-4 flex justify-center items-center gap-2">
            <Users size={20} /> Utviklet av
          </h2>

          <p className="text-gray-700 mb-2">
            Team Fontenehuset – i samarbeid med fellesskapet og frivillige
            utviklere.
          </p>

          <div className="flex justify-center items-center gap-6 mt-4">
            <a
              href="mailto:post@fontenehuset-oslosor.no"
              className="flex items-center gap-2 text-orange-600 hover:text-orange-700 transition"
            >
              <Mail size={18} /> E-post
            </a>
            <a
              href="https://github.com/Fontenehuset-Mortensrud"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-orange-600 hover:text-orange-700 transition"
            >
              <Github size={18} /> GitHub
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
